import { useMemo } from 'react';

export const useCacheData = <DataType extends { id: number }>(data: DataType[]) =>
  useMemo(() => {
    if (!data) {
      return {};
    }

    const cache: Record<number, DataType> = {};

    data.forEach((data) => {
      cache[data.id] = data;
    });

    return cache;
  }, [data]);
